// UUID using normal Math.random(), if this ends up being an issue, use node-uuid
// and replace contentId

function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = Math.random() * 16 | 0;
        const v = ((c === 'x') ? (r) : (r & 0x3) | (0x8));
        return v.toString(16);
    });
}

export default uuidv4;
